// extracted by css-extract-rspack-plugin
export default {"body":"OwnerFields__body--OvoTY","note":"OwnerFields__note--Z5YsN","purpose":"OwnerFields__purpose--_LtDA"};